import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=755f4426&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=755f4426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f4426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755f4426')) {
      api.createRecord('755f4426', component.options)
    } else {
      api.reload('755f4426', component.options)
    }
    module.hot.accept("./Widget.vue?vue&type=template&id=755f4426&scoped=true&", function () {
      api.rerender('755f4426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/widget-preview/components/Widget.vue"
export default component.exports